import styled from 'styled-components';
import { colors } from 'app/shared/styles/_colors';
import { padding } from 'app/shared/styles/_spacing';
import { variables } from 'app/shared/styles/_variables';
import { viewports } from 'app/shared/styles/_breakpoints';
import Text from 'app/shared/core/Text';
import ListingHeaderBase from 'app/shared/modules/MobileSRP/ListingCards/ListingHeader';

export const AreaPage = styled.div`
  background: ${colors['$hpx-white']};
  margin-top: 42px;

  @media ${viewports['md-and-up']} {
    width: ${variables['sidebar-width-md-bigger-listing-cards']};
  }

  @media ${viewports['xl-and-up-bigger-listing-cards']} {
    width: ${variables['sidebar-width-xl-bigger-listing-cards']};
  }
`;

export const AreaPageDivider = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  clear: both;
  width: 100%;
  border-bottom: 4px solid ${colors['$hpx-grey-100']};
`;

export const AreaPageLimitingText = styled.section`
  ${padding.top._3x};
  ${padding.bottom._3x};
  width: 85%;
  text-align: center;
  margin: auto;
`;

export const ListingHeader = styled(ListingHeaderBase)`
  ${padding.left._2x};
  ${padding.top._2x};
  ${padding.right._2x};
`;

export const DarkPageLimitNotice = styled(Text)`
  color: ${colors['$hpx-grey-600']};
`;
